<template>
  <div class="accordian-display card" :class="'card-' + containerClass">
    <div class="card-header">
      <span v-if="icon" :class="'fa fa-fw ' + icon"></span> {{ title }}
      <span
        @click="expandDetails = !expandDetails"
        class="fa fa-lg accordian-expand"
        :class="expandDetails ? 'fa-minus-square' : 'fa-plus-square'">
      </span>
    </div>
    <div v-if="expandDetails" class="card-body p-1">
      <table class="table table-bordered table-striped table-hover table-sm mb-0">
        <thead class="thead-light">
          <slot name="header"></slot>
        </thead>
        <tbody>
          <slot></slot>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordianDisplay',
  props: {
    containerClass: {
      type: String,
      default () {
        return 'secondary'
      }
    },
    title: {
      type: String
    },
    icon: {
      type: String,
      default () {
        return ''
      }
    },
    defaultOpen: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      expandDetails: false
    }
  },
  mounted () {
    if (this.defaultOpen) {
      this.expandDetails = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/AccordianDisplay.vue